import { graphql } from "relay-runtime"

export const deUndoDuplicatePatientsMutation = graphql`
  mutation deUndoDuplicatePatientsMutation($input: De_undoDuplicatePatientsInput!) {
    de_undoDuplicatePatients(input: $input) {
      de_Patient {
        id
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
